import { render, staticRenderFns } from "./ClassExercisePaper.vue?vue&type=template&id=42a2be2f&scoped=true"
import script from "./ClassExercisePaper.vue?vue&type=script&lang=js"
export * from "./ClassExercisePaper.vue?vue&type=script&lang=js"
import style0 from "./ClassExercisePaper.vue?vue&type=style&index=0&id=42a2be2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a2be2f",
  null
  
)

export default component.exports